function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M573.3 250C576.6 252.9 576.9 257.1 573.1 261.3C571.1 264.6 566 264.9 562.7 261.1L512 217.1V448C512 483.3 483.3 512 448 512H128C92.65 512 64 483.3 64 448V217.1L13.3 261.1C9.997 264.9 4.941 264.6 2.012 261.3C-.9182 257.1-.6116 252.9 2.696 250L282.7 2.011C285.7-.6704 290.3-.6704 293.3 2.011L573.3 250zM128 496H208V328C208 314.7 218.7 304 232 304H344C357.3 304 368 314.7 368 328V496H448C474.5 496 496 474.5 496 448V202.9L288 18.69L80 202.9V448C80 474.5 101.5 496 128 496V496zM224 496H352V328C352 323.6 348.4 320 344 320H232C227.6 320 224 323.6 224 328V496z"
});

function SvgHouseThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseThin);
export default __webpack_public_path__ + "static/media/house-thin.5ebbffd9.svg";
export { ForwardRef as ReactComponent };